import { Modal } from 'react-bootstrap';

const PermissionDeniedModal = ({ show, onHide = () => {} }) => {
  return (
    <Modal className="qa-checklist-modal" animation={false} show={show} size="md" centered onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Permission denied</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            There is duty on the load and you do not have the correct duty permissions to submit. Please speak to your
            Shift Leader.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 justify-content-between">
          <button className="epo-continue-button small-button" type="button" onClick={onHide}>
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PermissionDeniedModal;
